import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TranslateService } from '../../i18n/translate.service';

@Directive({
  selector: '[appFormErrorMessageDirective]',
  host: {
    '[class.text-red-500]': 'hasError',
  },
  standalone: true,
})
export class FormErrorMessageDirective implements OnChanges {
  @Input('appFormErrorMessageDirective') control!: AbstractControl | null | undefined;
  @Input() submitted = false;

  private subscription: Subscription = new Subscription();

  constructor(private el: ElementRef<HTMLElement>, readonly i18n: TranslateService) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.renderMessage();
  }

  ngOnInit(): void {
    if (!this.control) return;

    // Subscribe to changes (status + value)
    this.subscription.add(this.control.statusChanges.subscribe(() => this.renderMessage()));
    this.subscription.add(this.control.valueChanges.subscribe(() => this.renderMessage()));

    // Initial render
    this.renderMessage();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private renderMessage() {
    const msg = this.firstErrorMessage;
    this.el.nativeElement.textContent = msg ?? '';
  }

  get hasError(): boolean {
    return !!this.firstErrorMessage;
  }

  get firstErrorMessage(): string | null {
    const c = this.control;
    if (!c || !c.errors) return null;

    // show errors ONLY after submit button clicked
    if (!this.submitted) return null;

    const errors = c.errors;
    if (errors['required']) return this.i18n.t('thisFieldIsRequired');
    if (errors['email']) return this.i18n.t('invalidEmailAddress');
    if (errors['pattern']) return this.i18n.t('pleaseEnterAValidEmailAddress');
    if (errors['password']) return this.i18n.t('invalidPassword');
    if (errors['minlength']) return `Minimum length is ${errors['minlength'].requiredLength}`;
    if (errors['maxlength']) return `Maximum length is ${errors['maxlength'].requiredLength}`;
    if (errors['passwordMismatch']) return this.i18n.t('passwordsDoNotMatch');

    return this.i18n.t('invalidField');
  }
}
